module.exports = __webpack_public_path__ + "static/img/partner_20.a06c485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_20.png
// module id = FbwF
// module chunks = 0